module.exports = __webpack_public_path__ + "img/settings.9e2c3689.svg";